export default __webpack_public_path__ + "static/supportive-903d6955889f4622ff8e789a5810f133.svg";